import { project } from '../types';

// export const getProjectListAction = ({ customerId }) => ({
//     type: project.GET_PROJECT_LIST_REQUEST,
//     payload: { customerId },
// });

// export const getAllProjectList = ({ customerId }) => ({
//     type: project.GET_ALL_PROJECT_LIST_REQUEST,
//     payload: { customerId },
// });

export const getProjectDropDown = ({ customerId }) => {
    return { type: project.GET_ALL_PROJECT_DROPDOWN_LIST_REQUEST, payload: { customerId } };
};

export const updatePmDetails = ({ pm, type, projectId, formName, customerId }) => ({
    type: project.UPDATE_PM_DETAILS_REQUEST,
    payload: { pm, type, projectId, formName, customerId },
});

export const projectPostStatus = ({ status, projectId, postId, formName }) => ({
    type: project.PROJECT_POST_STATUS_REGUEST,
    payload: { status, projectId, postId, formName },
});
export const getProjectsCount = (customer_id) => ({
    type: project.PROJECTS_COUNT_REQUEST,
    payload: { customer_id },
});

export const editProject = ({ formValues, activeTab = 'ongoing', customerId, limit = 10, page = 1, type, formName }) => {
    return {
        type: project.EDIT_PROJECT_REQUEST,
        payload: { formValues, activeTab, customerId, limit, page, type, formName },
    };
};

export const emailTomorrowsPlannedTicketsCsv = (data) => ({
    type: project.EMAIL_PLANNED_TICKETS_CSV_REQUEST,
    payload: { data },
});

export const emailTodaysConfigCompleteTicketsCsv = (data) => ({
    type: project.EMAIL_CONFIG_COMPLETE_TICKETS_CSV_REQUEST,
    payload: { data },
});

export const createProject = ({ projectForm, formName, navigate, orgId }) => ({
    type: project.CREATE_PROJECT_REQUEST,
    payload: { projectForm, formName, navigate, orgId },
});

export const getProjectPrequisites = () => ({
    type: project.PROJECT_PREQUISITE_LIST_REQUEST,
});

export const getListOfTemplates = (data) => ({
    type: project.SHOW_TEMPLATE_LIST_REQUEST,
    payload: { data },
});

export const showAddProject = ({ isOpen, mainDiv, showProjectDetails }) => ({
    type: project.IS_SHOW_ADD_PROJECT,
    payload: { isOpen, mainDiv, showProjectDetails },
});

export const addTeamProject = ({ teams, projectId, customerId, formName, callLinkedProjectList }) => ({
    type: project.ADD_TEAM_PROJECT_REQUEST,
    payload: { teams, projectId, customerId, formName, callLinkedProjectList },
});

export const removeTeamProject = ({ teamId, projectId, customerId, teamName, projectName, formName, closeModal, refresh }) => ({
    type: project.REMOVE_TEAM_PROJECT_REQUEST,
    payload: { teamId, projectId, customerId, teamName, projectName, formName, closeModal, refresh },
});

export const getProjectTeams = ({ customerId, dropdown = false, count = false, projectId, agentsInfo }) => ({
    type: project.PROJECT_TEAM_LIST_REQUEST,
    payload: { customerId, dropdown, count, projectId, agentsInfo },
});

export const projectTeamWhiteList = ({ projectId, userId, customerId, customeMessage, formName, refresh, callGetLinkedProject }) => {
    return {
        type: project.PROJECTS_TEAMS_USER_WHITELIST_REQUEST,
        payload: { projectId, userId, customerId, customeMessage, formName, callGetLinkedProject, refresh },
    };
};

export const projectTeamBlackList = ({ projectId, userId, customerId, customeMessage, formName, refresh, callGetLinkedProject }) => {
    return {
        type: project.PROJECTS_TEAMS_USER_BLACKLIST_REQUEST,
        payload: { projectId, userId, customerId, customeMessage, formName, callGetLinkedProject, refresh },
    };
};

export const downloadProjectZip = ({ projectId, emails, formName }) => ({
    type: project.DOWNLOAD_PROJECT_ZIP_REQUEST,
    payload: { projectId, emails, formName },
});

export const getScogoDealIdsDropdownList = (customerId) => ({
    type: project.GET_SCOGO_DEALIDS_DROPDOWN_REQUEST,
    payload: { customerId },
});

export const clearDealListFromStore = () => ({
    type: project.CLEAR_DEAL_DROPDOWN_LIST_FROM_STORE,
});

export const createProjectTextPost = ({ message, projectId, formName }) => ({
    type: project.CREATE_PROJECT_TEXT_POST_REQUEST,
    payload: { message, projectId, formName },
});

// export const createProjectAttachmentPost = ({ caption, projectId, attachment, formName }) => ({
//     type: project.CREATE_PROJECT_ATTACHMENT_POST_REQUEST,
//     payload: { caption, projectId, attachment, formName },
// });
export const createProjectPost = ({ payload, projectId, formName }) => ({
    type: project.CREATE_PROJECT_POST_REQUEST,
    payload: { payload, projectId, formName }
})

export const getLinkedProjectOfUsers = ({ userId }) => ({
    type: project.GET_LINKED_PROJECT_OF_USERS_REQUEST,
    payload: { userId }
});

export const getLinkedProjectOfTeams = ({ teamId }) => ({
    type: project.GET_LINKED_PROJECT_OF_TEAMS_REQUEST,
    payload: { teamId }
});


export const createProjectTemplate = ({ createTemplateData, formName, formData, projectId }) => ({
    type: project.CREATE_PROJECT_TEMPLATE,
    payload: { createTemplateData, formName, formData, projectId },
});

export const createWorkflow = ({ templateData, formName, checkListdata, showToast }) => ({
    type: project.CREATR_WORKFLOW,
    payload: { templateData, formName, checkListdata, showToast },
});

export const editProjectPMRequest = ({ projectId, formName, fist_pm_id, second_pm_id, third_pm_id, escalate_manager
}) => ({
    type: project.EDIT_PROJECT_PM_REQUEST,
    payload: { projectId, formName, fist_pm_id, second_pm_id, third_pm_id, escalate_manager },
});

export const getProjectPMRequest = ({ projectId }) => ({
    type: project.GET_PROJECT_PM_REQUEST,
    payload: { projectId },
});


export const addMutlipleProjectsInTeams = ({ teamId, projectIds, formName, callLinkedProjectList }) => ({
    type: project.ADD_MULTIPLE_PROJECTS_IN_TEAM_PROJECT_REQUEST,
    payload: { teamId, projectIds, formName, callLinkedProjectList },
});

export const addSlaInProject = ({ wh_end_time, wh_start_time, sla_type, tier_1, tier_2, tier_3, tier_4, is_applicable, formName, projectId }) => ({
    type: project.ADD_SLA_IN_PROJECT_REQUEST,
    payload: { wh_end_time, wh_start_time, sla_type, tier_1, tier_2, tier_3, tier_4, is_applicable, formName, projectId },
});


export const getProjectSla = ({ projectId }) => ({
    type: project.GET_PROJECTS_SLA_REQUEST,
    payload: { projectId },
});

export const getProjectListData = ({ limit, page, query, dropdown, payload }) => ({
    type: project.GET_PROJECTS_LIST_DATA_REQUEST,
    payload: { limit, page, query, dropdown, payload },
})

// Auto Accept — fetch a page of projects for the given category + search query.
// `append` distinguishes infinite-scroll "load more" (append) from a fresh
// category/search load (replace). Search is server-side via the `q` param.
export const getAutoAcceptProjectList = ({ category, query, page = 1, append = false } = {}) => ({
    type: project.GET_AUTO_ACCEPT_PROJECT_LIST_REQUEST,
    payload: { category: category || null, query: query || '', page, append },
})

export const clearAutoAcceptProjectList = () => ({
    type: project.CLEAR_AUTO_ACCEPT_PROJECT_LIST,
})

// export const getContactPersonDetails = ({ orgId }) => ({
//     type: project.GET_CONTACT_PERSON_DETAILS_REQUEST,
//     payload: { orgId }
// })

export const getProjectDetail = ({ projectId }) => ({
    type: project.GET_PROJECT_DETAIL_REQUEST,
    payload: { projectId }
})
export const updateProjectDetail = ({ projectId, projectForm, formName, source }) => ({
    type: project.UPDATE_PROJECT_REQUEST,
    payload: { projectId, projectForm, formName, source }
})

export const getProjectPmsList = ({ can_manage_projects, query, limit = 100, page = 1, org_id }) => ({
    type: project.GET_PROJECT_ELIGIBLE_PMS_LIST_REQUEST,
    payload: { can_manage_projects, query, limit, page, org_id }
})


export const getTeamListOFProject = ({ projectId }) => ({
    type: project.GET_TEAM_LIST_OF_PROJECT_REQUEST,
    payload: { projectId }
})


export const addTeamToProject = ({ projectId, team_ids, formName }) => ({
    type: project.ADD_TEAM_TO_PROJECT_REQUEST,
    payload: { projectId, team_ids, formName }
})

export const removeTeamFromProject = ({ projectId, team_ids, formName }) => ({
    type: project.REMOVE_TEAM_FROM_PROJECT_REQUEST,
    payload: { projectId, team_ids, formName }
})



export const getProjectPostList = ({ projectId }) => ({
    type: project.GET_PROJECT_POST_LIST_REQUEST,
    payload: { projectId },
});




export const updateProjectPost = ({ projectId, postId, status, formName }) => ({
    type: project.UPDATE_PROJECT_POST_REQUEST,
    payload: { projectId, postId, status, formName }
})


export const getProjectFilterList = ({ filter_labels }) => ({
    type: project.GET_PROJECT_FILTER_LIST_REQUEST,
    payload: { filter_labels }
})

export const getMilestoneList = ({ projectId }) => ({
    type: project.GET_MILESTONE_LIST_REQUEST,
    payload: { projectId }
})

export const postMilestone = ({ projectId, milestone, formName }) => ({
    type: project.POST_MILESTONE_REQUEST,
    payload: { projectId, milestone, formName }
})

export const postMilestoneById = ({ projectId, projectMilestoneId, milestone }) => ({
    type: project.POST_MILESTONE_BY_ID_REQUEST,
    payload: { projectId, projectMilestoneId, milestone }
})

export const postProjectManager = ({ payload, projectId, formName }) => ({
    type: project.POST_PROJECT_MANAGER_REQUEST,
    payload: { payload, projectId, formName }
})

export const getProjectManager = ({ projectId }) => ({
    type: project.GET_PROJECT_MANAGER_REQUEST,
    payload: { projectId }
})
export const addTeamsToProject = ({ id, team_ids }) => ({
    type: project.ADD_TEAMS_TO_PROJECT_REQUEST,
    payload: { id, team_ids }
})


export const getMilestones = ({ org_id, query, dropdown, limit, page }) => ({
    type: project.GET_MILESTONES_REQUEST,
    payload: { org_id, query, dropdown, limit, page }
})


export const blackListUserFromProject = ({ projectId, user_id, formName, team_id }) => ({
    type: project.BLACK_LIST_USER_FROM_PROJECT_REQUEST,
    payload: { projectId, user_id, formName, team_id }
})

export const whiteListUserFromProject = ({ projectId, user_id, formName, team_id }) => ({
    type: project.WHITE_LIST_USER_FROM_PROJECT_REQUEST,
    payload: { projectId, user_id, formName, team_id }
})



export const addProjectPo = ({ projectId, payload, formName }) => ({
    type: project.ADD_PROJECT_PO_REQUEST,
    payload: { projectId, payload, formName }
})

export const editProjectPo = ({ projectId, poId, amount, formName }) => ({
    type: project.EDIT_PROJECT_PO_REQUEST,
    payload: { projectId, poId, amount, formName }
})

export const getProjectPo = ({ projectId }) => ({
    type: project.GET_PROJECT_PO_REQUEST,
    payload: { projectId }
})

export const getProjectChecklist = ({ projectId }) => ({
    type: project.GET_PROJECT_CHECKLIST_REQUEST,
    payload: { projectId }
})
export const editProjectChecklist = ({ projectId, checklistId, checklist, formName }) => ({
    type: project.EDIT_PROJECT_CHECKLIST_REQUEST,
    payload: { projectId, checklistId, checklist, formName }
})

export const activateProject = ({ id, payload, formName, source }) => ({
    type: project.ACTIVATE_PROJECT_REQUEST,
    payload: { id, payload, formName, source }
});
